<template>
    <el-dialog @close='closeDialog' title="转移题目" :visible.sync="dialogVisible">
        <div class="transfer_pop_box">
            <el-tree :data="data" @node-click="handleNodeClick"></el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureBtn()">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
// import {findGoodsList, addGoods} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'TransferPop',
    // props: ['addGoodsData'],
    data() {
        return {
            dialogVisible: false,
            data: []
        }
    },
    mounted() {},
    methods: {
        // 打开弹窗
        openDialog(val, val2) {
            this.dialogVisible = true
            // console.log(val)
            this.data = val
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        handleNodeClick(data) {
            console.log(data)
        },
        // 确定按钮
        sureBtn() {},
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .transfer_pop_box {
        height: 280px;
        overflow: auto;
        .el-tree-node__content {
            height: 40px;
        }
    }
    .transfer_pop_box::-webkit-scrollbar {
        width: 4px;
    }
    .transfer_pop_box::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background:rgba(229,229,229,1);
    }
    .transfer_pop_box::-webkit-scrollbar-track {
        border-radius: 2px;
        background: #fff;
    }
    .el-tree .el-tree-node.is-current > .el-tree-node__content {
        background-color: #FAFAFA;
        color: #409EFF;
    }
</style>
